import {defineMessages} from 'react-intl';

export default defineMessages({
    all: {
        defaultMessage: 'All',
        description: 'Tag for filtering a library for everything',
        id: 'gui.libraryTags.all'
    },
    animals: {
        defaultMessage: 'Animals',
        description: 'Tag for filtering a library for animals',
        id: 'gui.libraryTags.animals'
    },
    dance: {
        defaultMessage: 'Dance',
        description: 'Tag for filtering a library for dance',
        id: 'gui.libraryTags.dance'
    },
    effects: {
        defaultMessage: 'Effects',
        description: 'Tag for filtering a library for effects',
        id: 'gui.libraryTags.effects'
    },
    fantasy: {
        defaultMessage: 'Fantasy',
        description: 'Tag for filtering a library for fantasy',
        id: 'gui.libraryTags.fantasy'
    },
    fashion: {
        defaultMessage: 'Fashion',
        description: 'Tag for filtering a library for fashion',
        id: 'gui.libraryTags.fashion'
    },
    food: {
        defaultMessage: 'Food',
        description: 'Tag for filtering a library for food',
        id: 'gui.libraryTags.food'
    },
    indoors: {
        defaultMessage: 'Indoors',
        description: 'Tag for filtering a library for indoors',
        id: 'gui.libraryTags.indoors'
    },
    loops: {
        defaultMessage: 'Loops',
        description: 'Tag for filtering a library for loops',
        id: 'gui.libraryTags.loops'
    },
    music: {
        defaultMessage: 'Music',
        description: 'Tag for filtering a library for music',
        id: 'gui.libraryTags.music'
    },
    notes: {
        defaultMessage: 'Notes',
        description: 'Tag for filtering a library for notes',
        id: 'gui.libraryTags.notes'
    },
	other: {
        defaultMessage: 'Other Scratch Mods',
        description: 'Tag for filtering a library for extensions from other modifications',
        id: 'pot.libraryTags.other'
    },
    outdoors: {
        defaultMessage: 'Outdoors',
        description: 'Tag for filtering a library for outdoors',
        id: 'gui.libraryTags.outdoors'
    },
    patterns: {
        defaultMessage: 'Patterns',
        description: 'Tag for filtering a library for patterns',
        id: 'gui.libraryTags.patterns'
    },
    people: {
        defaultMessage: 'People',
        description: 'Tag for filtering a library for people',
        id: 'gui.libraryTags.people'
    },
    percussion: {
        defaultMessage: 'Percussion',
        description: 'Tag for filtering a library for percussion',
        id: 'gui.libraryTags.percussion'
    },
	potentia: {
        defaultMessage: 'PotentiaMod',
        description: 'Tag for filtering a library for PotentiaMod-created content',
        id: 'pot.libraryTags.pot'
    },
    space: {
        defaultMessage: 'Space',
        description: 'Tag for filtering a library for space',
        id: 'gui.libraryTags.space'
    },
    sports: {
        defaultMessage: 'Sports',
        description: 'Tag for filtering a library for sports',
        id: 'gui.libraryTags.sports'
    },
    underwater: {
        defaultMessage: 'Underwater',
        description: 'Tag for filtering a library for underwater',
        id: 'gui.libraryTags.underwater'
    },
    voice: {
        defaultMessage: 'Voice',
        description: 'Tag for filtering a library for voice',
        id: 'gui.libraryTags.voice'
    },
    wacky: {
        defaultMessage: 'Wacky',
        description: 'Tag for filtering a library for wacky',
        id: 'gui.libraryTags.wacky'
    },
    animation: {
        defaultMessage: 'Animation',
        description: 'Tag for filtering a library for animation',
        id: 'gui.libraryTags.animation'
    },
    art: {
        defaultMessage: 'Art',
        description: 'Tag for filtering a library for art',
        id: 'gui.libraryTags.art'
    },
    games: {
        defaultMessage: 'Games',
        description: 'Tag for filtering a library for games',
        id: 'gui.libraryTags.games'
    },
    stories: {
        defaultMessage: 'Stories',
        description: 'Tag for filtering a library for stories',
        id: 'gui.libraryTags.stories'
    },
    letters: {
        defaultMessage: 'Letters',
        description: 'Tag for filtering a library for letters',
        id: 'gui.libraryTags.letters'
    },
    graphics: {
        defaultMessage: 'Graphics',
        description: 'Tag for filtering a library for graphics',
        id: 'pot.gui.libraryTags.graphics'
    },
    sound: {
        defaultMessage: 'Sound',
        description: 'Tag for filtering a library for sound',
        id: 'pot.gui.libraryTags.sound'
    },
    math: {
        defaultMessage: 'Math',
        description: 'Tag for filtering a library for math',
        id: 'pot.gui.libraryTags.math'
    },
    data: {
        defaultMessage: 'Data Management',
        description: 'Tag for filtering a library for data',
        id: 'pot.gui.libraryTags.data'
    },
    hardware: {
        defaultMessage: 'Hardware',
        description: 'Tag for filtering a library for hardware',
        id: 'pot.gui.libraryTags.hardware'
    },
    internet: {
        defaultMessage: 'Internet',
        description: 'Tag for filtering a library for internet',
        id: 'pot.gui.libraryTags.internet'
    },
    expansion: {
        defaultMessage: 'Category Expansion',
        description: 'Tag for filtering a library for expansions',
        id: 'pot.gui.libraryTags.expansion'
    },
    type: {
        defaultMessage: 'Types',
        description: 'Tag for filtering a library for data types',
        id: 'pot.gui.libraryTags.type'
    },
    language: {
        defaultMessage: 'Programming Language',
        description: 'Tag for filtering a library for programming languages',
        id: 'pot.gui.libraryTags.language'
    },
    library: {
        defaultMessage: 'Extension Gallery',
        description: 'Tag for filtering a library for extension libraries',
        id: 'pot.gui.libraryTags.library'
    },
    customextension: {
        defaultMessage: 'Load Custom Extension',
        description: 'Button to load a custom extension',
        id: 'pot.gui.libraryTags.customextension'
    }
});
